import { Component, OnInit, Signal, inject } from '@angular/core';
import { RxAlertModule } from '@roomex/rx-components';
import { TemporaryApproverStore } from '@rx-applications/clientsite/temporary-approver/data-access';
import { CommonModule } from '@angular/common';
import { translationProvider as TranslationsProvider, TRANSLATION_SCOPE } from './assets/i18n/translation.provider';
import { TranslocoModule } from '@ngneat/transloco';
import { FULL_DAY_NAME_MONTH_NAME_WITH_TIME } from '@rx-applications/shared/utils';
import { toSignal } from '@angular/core/rxjs-interop';
import { PrimaryApproverOutOfOfficePeriod } from '@rx-applications/clientsite/temporary-approver/utils';

@Component({
  selector: 'rx-applications-temporary-approver-note',
  standalone: true,
  imports: [RxAlertModule, CommonModule, TranslocoModule],
  providers: [TemporaryApproverStore, TranslationsProvider],
  templateUrl: './temporary-approver-note.component.html',
  styleUrl: './temporary-approver-note.component.scss',
})
export class TemporaryApproverNoteComponent implements OnInit {
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  readonly FULL_DAY_NAME_MONTH_NAME_WITH_TIME = FULL_DAY_NAME_MONTH_NAME_WITH_TIME;

  #temporaryApproverStore$ = inject(TemporaryApproverStore);
  readonly primaryPeriodsExpiringAfter24h: Signal<PrimaryApproverOutOfOfficePeriod[]> = toSignal(
    this.#temporaryApproverStore$.primaryPeriodsExpiringAfter24h$,
  );
  readonly primaryPeriodsExpiringSoon: Signal<PrimaryApproverOutOfOfficePeriod[]> = toSignal(
    this.#temporaryApproverStore$.primaryPeriodsExpiringSoon$,
  );

  ngOnInit(): void {
    this.#temporaryApproverStore$.gePrimaryApproverOutOfOfficePeriods();
  }
}
